export default __webpack_public_path__ + "static/media/roadhog-hook2.ed1f13b0.mp3";